// src/components/orderentry/panels/LastPricePanel.jsx
// -----------------------------------------------------------------------------
// AREA 4 — LAST PRICE (12 months)
//
// Responsibilities:
//  - Display last invoice line for the selected item/customer/ship-to
//  - Render a compact 1-row "grid"
//  - Keep UI consistent even when no data is available
// -----------------------------------------------------------------------------

import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import GridBadge from '../components/GridBadge.jsx';
import MoneyCell from '../components/MoneyCell.jsx';

export default function LastPricePanel({
  masId,
  shipId,
  rowHeight,
  lastPriceRow, // { invoiceDate, itemCode, unitPrice, terms } | null
}) {
  // Only show the panel when customer context exists
  if (!masId || !shipId) {
    return null;
  }

  return (
    <Box sx={{ position: 'relative', minWidth: 0 }}>
      <GridBadge n="4" />

      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
        Last Price (12 months)
      </Typography>

      <Box
        sx={{
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          bgcolor: 'background.paper',
          px: 1,
          py: 0.5,
          minWidth: 0,
          overflowX: 'auto',
          minHeight: rowHeight * 1.2,
          maxHeight: rowHeight * 5,
          overflowY: 'auto',
        }}
      >
        {!lastPriceRow && (
          <Typography variant="body2" color="text.secondary">
            No last invoice found for this item.
          </Typography>
        )}

        {lastPriceRow && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '100px 80px 90px 1fr',
              gap: 1,
              alignItems: 'center',
              minWidth: 360,
            }}
          >
            <Typography variant="body2">{lastPriceRow.invoiceDate || '—'}</Typography>
            <Typography variant="body2">{lastPriceRow.itemCode || '—'}</Typography>

            {/* Currency formatting */}
            <Typography variant="body2">
              <MoneyCell value={lastPriceRow.unitPrice} />
            </Typography>

            {/* Terms can be long; show ellipsis + tooltip */}
            <Typography
              variant="body2"
              sx={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
              title={lastPriceRow.terms || ''}
            >
              {lastPriceRow.terms || '—'}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
